/* global Chart */
import { Line, mixins } from 'vue-chartjs'

const { reactiveProp } = mixins

export default {
  extends: Line,
  mixins: [reactiveProp],
  props: ['options'],
  mounted() {
    // Pretty much remove pointers
    Chart.defaults.global.elements.point.radius = 0
    // Overwrite default draw function to retrieve the index of the vertical line
    const originalLineDraw = Chart.controllers.line.prototype.draw
    Chart.helpers.extend(Chart.controllers.line.prototype, {
      draw() {
        // eslint-disable-next-line
        originalLineDraw.apply(this, arguments)
        // Check for an active tooltip
        // eslint-disable-next-line
        if (this.chart.tooltip._active && this.chart.tooltip._active.length) {
          // eslint-disable-next-line
          const activePoint = this.chart.tooltip._active[0],
            ctx = this.chart.ctx,
            x = activePoint.tooltipPosition().x,
            topY = this.chart.scales[Object.keys(this.chart.scales)[1]].top, // draw on first axes!
            bottomY = this.chart.scales[Object.keys(this.chart.scales)[1]].bottom
          // draw line
          ctx.save()
          ctx.beginPath()
          ctx.moveTo(x, topY)
          ctx.lineTo(x, bottomY)
          ctx.lineWidth = 2
          ctx.strokeStyle = '#FF0000'
          ctx.stroke()
          ctx.restore()
        }
      }
    })
    this.renderChart(this.chartData, this.options)
  }
}



// WEBPACK FOOTER //
// ./src/components/Map/line-chart.js